export let life = {
  created () {}
}
export let event = {
  clickClose () {
    this.methods('inputClose')
  }
}